import * as React from 'react';

import { useInViewport } from 'react-in-viewport';
import { Image as ImageType, renditions } from '../../types';
import s from './WideImage.module.scss';
import classNames from 'classnames';

import Image, {MediaQuery} from "../Image/Image";

export interface WideImageProps {
    image: ImageType;
    featuredImage?: boolean;
}

const WideImage: React.FC<WideImageProps> = ({ image, featuredImage = false }) => {
    const myRef = React.useRef();

    const {
      enterCount,
    } = useInViewport(
      myRef,
    );

    type GetMediaQueriesTypes = {
        renditions: renditions;
        featuredImage: boolean;
    };

    const getMediaQueries = ({
        renditions,
        featuredImage,
    }: GetMediaQueriesTypes): MediaQuery[] => {
        let mediaQueries = [];
        if (!featuredImage) {
            mediaQueries = [
                { minWidth: 1440, src: renditions?.xl.src },
                { minWidth: 1280, src: renditions?.large.src },
            ];
        }

        mediaQueries = [
            ...mediaQueries,
            { minWidth: 960, src: renditions?.xl.src },
            { minWidth: 768, src: renditions?.large.src },
            { minWidth: 480, src: renditions?.medium.src },
            { minWidth: 360, src: renditions?.small.src },
        ];

        return mediaQueries.filter((x) => x.src);
    };

    const classes = classNames(s.Root, {
        [s.ImageInView]: enterCount > 0
    })

    return (
        <div className={classes} ref={myRef}>
            {image && (
                <Image
                    image={image.renditions?.large || image}
                    className={s.Image}
                    showImage={true}
                    mediaQueries={getMediaQueries({
                        renditions: image.renditions,
                        featuredImage: featuredImage,
                    })}
                />
            )}
            {image && image.caption && (
                <p className={s.Caption}>{image.caption}</p>
            )}
        </div>
    );
};

export default WideImage;
